export default __webpack_public_path__ + "static/media/Shroud of the Ghost Crow's Spite.97ee67cd.jpg";